export default function Step1() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="38" viewBox="0 0 36 38" fill="none">
            <path d="M27.5 6.29395C24.933 4.5403 21.3434 3.29395 18 3.29395C9.16344 3.29395 2 10.4574 2 19.2939C2 19.7843 2.02205 20.2694 2.06523 20.7485M7.5 31.2939C10.2633 33.568 14.1419 35.2939 18 35.2939C26.8366 35.2939 34 28.1305 34 19.2939C34 18.4231 33.9304 17.5685 33.7965 16.7354" stroke="black" strokeWidth="2.5" strokeLinecap="round"/>
            <path d="M27.1962 1.29395L30.1962 6.4901L25 9.4901" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.55283 35.8425L4.99992 30.0469L10.7955 28.494" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
